import { InputAdornment } from '@mui/material';
import withStyles from '@mui/styles/withStyles';
import { Grid, IconButton, TextField, Tooltip } from '@mui/material'
import { RemoveRedEye, Refresh } from '@mui/icons-material';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import AbEnvironment from '../auth/AbEnvironment';

const styleSheet = theme => ({
  eye: {
    cursor: 'pointer',
  },
  passwordField: {
    marginTop: 0,
    minWidth: 336
  },
  iconButton: {
    paddingLeft: 8,
    paddingRight: 8,
    paddingTop: 2,
    paddingBottom: 2,
  },
  iconButtonAction: {
    paddingLeft: 8,
    paddingRight: 8,
    paddingTop: 3,
    paddingBottom: 2,
  },
});

const abEnvironment = new AbEnvironment();

class PasswordInput extends Component {

  constructor(props) {
    super(props);

    this.state = {
      passwordIsMasked: true,
      pwd: ''
    };
  }

  togglePasswordMask = () => {
    this.setState(prevState => ({
      passwordIsMasked: !prevState.passwordIsMasked,
    }));
  };

  componentDidMount() {

    const { callPartnerApi, decryptOneTimeEncryptedValue } = this.props.auth;

    if (this.props.pwd && this.props.pwd !== '') {
 
      // Initiate promise chain.
      Promise.resolve()  
      .then(() => {
        // We've got an encrypted password, and want the decrypted version.  We also will employ
        // additional encryption in transit (which is duplicative to TLS, but is an extra defense
        // against sniffing).  So:
        // - call the server side "getDecryptedSubscriptionString", a replacement for the
        //   "getSubscriptionString" operation
        // - this returns a decryptString and a oneTimeKeyId
        // - call the server side "getOneTimeKey" operation, passing the oneTimeKeyId as a parameter
        // - use the returned key to decrypt the decryptString
        //

        // console.log('password=' + this.props.pwd);

        let payload = {
          operation: "getDecryptedSubscriptionString",
          params: {
            customerAppId: this.props.customerAppId,
            aString: this.props.pwd
          }
        };

        // console.log('call getDecryptedSubscriptionString');
        return callPartnerApi('appbind/generic',
                              'POST',
                              payload);
      })
      .then((response) => {
        return response.json();
      })
      .then((jresp) => {
        // console.log(JSON.stringify(jresp));
        let theKeyId = jresp.theKeyId;
        let decryptResp = jresp.decryptResp;

        return decryptOneTimeEncryptedValue(theKeyId, decryptResp, callPartnerApi);
      })
      .then((unencrypted) => {
        if (unencrypted != null) {
          this.setState({pwd: unencrypted});
        }
      })
      .catch((error) => {
        //not sure what we can do
      });
    }
  }

  generatePassword() {

    //console.log('password=' + this.props.pwd);

    const { callPartnerApi } = this.props.auth;

    let aPjwt = abEnvironment.getPjwt();

    // Initiate promise chain.
    Promise.resolve()  
    .then(() => {
      // Call the server side decryption

      let payload = {
        operation: "generatePassword",
        params: {
          pJwt:    aPjwt
        }
      };

      return callPartnerApi('appbind/generic',
                            'POST',
                              payload);
    })
    .then((response) => {
      return response.json();
    })
    .then((jresp) => {
      //console.log(JSON.stringify(jresp));
      //console.log(jresp);
      this.setState({pwd: jresp.data});
      this.props.onChange(jresp.data);
    })
    .catch((error) => {
      //not sure what we can do
    });

  }

  setUnencryptedPassword(e) {
    if (! this.props.readonly === true) {
      this.setState({pwd: e.target.value});
      this.props.onChange(e.target.value);
    }
  }
  
  setClipboardVal(theText) {
    navigator.clipboard.writeText(theText)
    .then(() => {

    })
    .catch(err => {

    })
  }

  render() {
    const { classes } = this.props;

    let eyeIconColor = 'primary';
    if (this.state.passwordIsMasked) {
      eyeIconColor = 'secondary';
    }

    let theVariant = 'standard';
    if (this.props.variant) {
      theVariant = this.props.variant;
    }

    if (this.props.displayOnly) {
      return (
        <Grid justifyContent="space-between" container>
          <Grid item>
            <TextField
              id={"appbind-shared-password" + this.props.customerAppId}
              label={this.props.label}
              type={this.state.passwordIsMasked ? 'password' : 'text'}
              value={this.state.pwd}
              className={classes.passwordField}
              InputProps={{ readOnly: true, disableUnderline: true,
                endAdornment: (
                  <InputAdornment position="end">
                    <RemoveRedEye 
                      color={eyeIconColor}
                      className={classes.eye}
                      onClick={this.togglePasswordMask}
                    />
                  </InputAdornment>
                ),
              }}
            />
          </Grid>
          <Grid item>
            <Tooltip placement='bottom' title='Copy shared password to clipboard'>
              <IconButton
                className={classes.iconButton}
                onClick={() => {this.setClipboardVal(this.state.pwd); }}
                size="large">
                <img alt="Copy to Clipboard" 
                     src='/images/content_copy_black_24x24.png' 
                     height="14px"/>
              </IconButton>
            </Tooltip>     
          </Grid>
        </Grid>
      );

    } else {

      let basicDisplay = this.props.basicDisplay;
      if (basicDisplay == null) {
        basicDisplay = false;
      }
      return (
        <Grid container justifyContent="flex-start" alignItems="center" spacing={1}>
          <Grid item>
            <TextField
              id={"appbind-shared-password" + this.props.customerAppId}
              label={this.props.label}
              type={this.state.passwordIsMasked ? 'password' : 'text'}
              value={this.state.pwd}
              disabled={this.props.disabled}
              readOnly={this.props.readonly}
              variant={theVariant}
              className={classes.passwordField}
              onChange={(e) => {this.setUnencryptedPassword(e)}}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <RemoveRedEye 
                      color={eyeIconColor}
                      className={classes.eye}
                      onClick={this.togglePasswordMask}
                    />
                  </InputAdornment>
                ),
              }}
            />
          </Grid>
          <Grid item>
            {!basicDisplay &&
            <Tooltip placement='bottom' title='Copy shared password to clipboard'>
              <IconButton
                className={classes.iconButton}
                onClick={() => {this.setClipboardVal(this.state.pwd); }}
                size="large">
                <img alt="Copy to Clipboard" 
                     src='/images/content_copy_black_24x24.png' 
                     height="16px"/>
              </IconButton>
            </Tooltip>}
            {(!this.props.disabled && !basicDisplay) &&
            <Tooltip placement='bottom' title='Generate new shared password'>
              <IconButton
                className={classes.iconButtonAction}
                onClick={() => {this.generatePassword(); }}
                size="large">
                <Refresh/>
              </IconButton>
            </Tooltip>}
          </Grid>
        </Grid>
      );
    }
  }
}

PasswordInput.propTypes = {
  classes: PropTypes.object.isRequired,
  decryptKey: PropTypes.string,
  pwd: PropTypes.string,
  onChange: PropTypes.func,
};

export default withStyles(styleSheet)(PasswordInput);